import { render, staticRenderFns } from "./contact-editor.vue?vue&type=template&id=635a1c38&scoped=true&"
import script from "./contact-editor.vue?vue&type=script&lang=js&"
export * from "./contact-editor.vue?vue&type=script&lang=js&"
import style0 from "./contact-editor.vue?vue&type=style&index=0&id=635a1c38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635a1c38",
  null
  
)

export default component.exports